import {Routes} from '@angular/router';

export const content: Routes = [
  {
    path: 'general',
    loadChildren: () => import('../../components/general/general.module').then(m => m.GeneralModule)
  },
  {
    path: 'students',
    loadChildren: () => import('../../components/students/students.module').then(m => m.StudentsModule)
  },
  {
    path: 'college',
    loadChildren: () => import('../../components/colleges/colleges.module').then(m => m.CollegesModule)
  },
  {
    path: 'referred-by',
    loadChildren: () => import('../../components/referred-by/referred-by.module').then(m => m.ReferredByModule)
  },
  {
    path: 'sessions',
    loadChildren: () => import('../../components/sessions/sessions.module').then(m => m.SessionsModule)
  },
  {
    path: 'modules',
    loadChildren: () => import('../../components/modules/module.module').then(m => m.ModuleModule)
  },
  {
    path: 'departments',
    loadChildren: () => import('../../components/department/department.module').then(m => m.DepartmentModule)
  },
  {
    path: 'docs',
    loadChildren: () => import('../../components/docs/docs.module').then(m => m.DocsModule)
  },
  {
    path: 'accounts',
    loadChildren: () => import('../../components/accounts/accounts.module').then(m => m.AccountsModule)
  },
  {
    path: 'access',
    loadChildren: () => import('../../components/access/access.module').then(m => m.AccessModule)
  },
  {
    path: 'support',
    loadChildren: () => import('../../components/support/support.module').then(m => m.SupportModule)
  },

  {
    path: 'notify',
    loadChildren: () => import('../../components/notification/notification.module').then(m => m.NotificationModule)
  },
  {
    path: 'exam',
    loadChildren: () => import('../../components/exam/exam.module').then(m => m.ExamModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('../../components/profile/profile.module').then(m => m.ProfileModule)
  },
  {
    path: 'enquiry',
    loadChildren: () => import('../../components/enquiry/enquiry.module').then(m => m.EnquiryModule)
  },
  {
    path: 'level',
    loadChildren: () => import('../../components/levels/levels.module').then(m => m.LevelsModule)
  },
  {
    path: 'student-profile',
    loadChildren: () => import('../../components/student-profile/student-profile.module').then(m => m.StudentProfileModule)
  }
];
